import { useState } from "react";
import { useLearnerCountry } from "@/hooks/useLearnerCountry";
import { COUNTRY_LABEL, type ContentCountry } from "@/lib/learnerCountry";
import { toast } from "@/hooks/use-toast";

export function ContentCountryCard() {
  const { country, source, setCountry } = useLearnerCountry();
  const [busy, setBusy] = useState(false);
  const pick = async (c: ContentCountry) => {
    if (c === country) return;
    setBusy(true);
    try {
      await setCountry(c);
      toast({ title: "Country updated", description: `You'll now see ${COUNTRY_LABEL[c]} colleges, exams and roadmaps.` });
    } catch {
      toast({ title: "Couldn't update your country", description: "Please try again.", variant: "destructive" });
    } finally { setBusy(false); }
  };
  return (
    <section className="rounded-3xl border border-border bg-card p-6">
      <h2 className="font-display text-xl font-semibold">Your country</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        Sets which colleges, exams, pay and roadmaps you see.
        {source === "payment" && " We set this from your payment; you can change it."}
      </p>
      <div role="radiogroup" aria-label="Content country" className="mt-4 flex gap-2">
        {(["IN", "US"] as ContentCountry[]).map((c) => (
          <button key={c} type="button" role="radio" aria-checked={country === c} disabled={busy}
            onClick={() => pick(c)}
            className={`min-h-12 rounded-full border px-5 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${country === c ? "border-primary bg-primary/15 text-primary" : "border-border text-foreground hover:border-primary/50"}`}>
            {COUNTRY_LABEL[c]}
          </button>
        ))}
      </div>
    </section>
  );
}
